/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type { GetSpotSolution429, GetSpotSolutionParams, GetSpotSolutionResponse } from '../models'

import getSpotSolutionMutator from '../../../client'

type AwaitedInput<T> = PromiseLike<T> | T

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never

/**
 * @summary Get Spot Solution
 */
export const getSpotSolution = (params?: GetSpotSolutionParams, signal?: AbortSignal) => {
  return getSpotSolutionMutator<GetSpotSolutionResponse | void>({
    url: `/v4/solutions/spot-solution/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getGetSpotSolutionQueryKey = (params?: GetSpotSolutionParams) => {
  return [`/v4/solutions/spot-solution/`, ...(params ? [params] : [])] as const
}

export const getGetSpotSolutionQueryOptions = <
  TData = Awaited<ReturnType<typeof getSpotSolution>>,
  TError = void | GetSpotSolution429,
>(
  params?: GetSpotSolutionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpotSolution>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSpotSolutionQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpotSolution>>> = ({ signal }) =>
    getSpotSolution(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSpotSolution>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpotSolutionQueryResult = NonNullable<Awaited<ReturnType<typeof getSpotSolution>>>
export type GetSpotSolutionQueryError = void | GetSpotSolution429

export function useGetSpotSolution<
  TData = Awaited<ReturnType<typeof getSpotSolution>>,
  TError = void | GetSpotSolution429,
>(
  params: undefined | GetSpotSolutionParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpotSolution>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpotSolution>>,
          TError,
          Awaited<ReturnType<typeof getSpotSolution>>
        >,
        'initialData'
      >
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpotSolution<
  TData = Awaited<ReturnType<typeof getSpotSolution>>,
  TError = void | GetSpotSolution429,
>(
  params?: GetSpotSolutionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpotSolution>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpotSolution>>,
          TError,
          Awaited<ReturnType<typeof getSpotSolution>>
        >,
        'initialData'
      >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpotSolution<
  TData = Awaited<ReturnType<typeof getSpotSolution>>,
  TError = void | GetSpotSolution429,
>(
  params?: GetSpotSolutionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpotSolution>>, TError, TData>>
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Spot Solution
 */

export function useGetSpotSolution<
  TData = Awaited<ReturnType<typeof getSpotSolution>>,
  TError = void | GetSpotSolution429,
>(
  params?: GetSpotSolutionParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpotSolution>>, TError, TData>>
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSpotSolutionQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getGetSpotSolutionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSpotSolution>>,
  TError = void | GetSpotSolution429,
>(
  params?: GetSpotSolutionParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpotSolution>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSpotSolutionQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpotSolution>>> = ({ signal }) =>
    getSpotSolution(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSpotSolution>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpotSolutionSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSpotSolution>>
>
export type GetSpotSolutionSuspenseQueryError = void | GetSpotSolution429

export function useGetSpotSolutionSuspense<
  TData = Awaited<ReturnType<typeof getSpotSolution>>,
  TError = void | GetSpotSolution429,
>(
  params: undefined | GetSpotSolutionParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpotSolution>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpotSolutionSuspense<
  TData = Awaited<ReturnType<typeof getSpotSolution>>,
  TError = void | GetSpotSolution429,
>(
  params?: GetSpotSolutionParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpotSolution>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpotSolutionSuspense<
  TData = Awaited<ReturnType<typeof getSpotSolution>>,
  TError = void | GetSpotSolution429,
>(
  params?: GetSpotSolutionParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpotSolution>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Spot Solution
 */

export function useGetSpotSolutionSuspense<
  TData = Awaited<ReturnType<typeof getSpotSolution>>,
  TError = void | GetSpotSolution429,
>(
  params?: GetSpotSolutionParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSpotSolution>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSpotSolutionSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
